import { render } from "./StatusFail.vue?vue&type=template&id=484ad5b3&scoped=true"
import script from "./StatusFail.vue?vue&type=script&lang=js"
export * from "./StatusFail.vue?vue&type=script&lang=js"

import "./StatusFail.vue?vue&type=style&index=0&id=484ad5b3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484ad5b3"]])

export default __exports__